import { render, staticRenderFns } from "./news_inner.vue?vue&type=template&id=f9b510ca&scoped=true"
import script from "./news_inner.vue?vue&type=script&lang=js"
export * from "./news_inner.vue?vue&type=script&lang=js"
import style0 from "./news_inner.vue?vue&type=style&index=0&id=f9b510ca&prod&lang=css"
import style1 from "./news_inner.vue?vue&type=style&index=1&id=f9b510ca&prod&lang=css"
import style2 from "./news_inner.vue?vue&type=style&index=2&id=f9b510ca&prod&scoped=true&lang=css"
import style3 from "./news_inner.vue?vue&type=style&index=3&id=f9b510ca&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9b510ca",
  null
  
)

export default component.exports